import React from "react";

const AlertBanner = () => {
  return (
    <div className="w-full relative z-[500] bg-[rgb(47,50,55)] text-[#edf3f5] min-h-[40px] flex items-start lg:items-center lg:justify-center py-[10px] px-[20px]">
      <p className="text-[14px] leading-5 lg:leading-6">
        Envío a todo México por $175 MXN. Entrega en 2-3 días hábiles.
        <span className="ml-[6px] font-semibold cursor-pointer hover:border-b-[1px] hover:border-[#edf3f5]">
          Aplican condiciones.
        </span>
      </p>
    </div>
  );
};

export default AlertBanner;
